import { useFlags } from "launchdarkly-react-client-sdk";

import { useExternalResourceLaunchEnabled } from "src/hooks/use-external-resource-launch-enabled";

/**
 * The one predicate every Ad Studio launch affordance consults, so they cannot diverge.
 * Off when the `disableAdStudioLaunch` kill switch is on, or when `externalResourceLaunch` moves launching to the agent.
 * Reads as enabled until LaunchDarkly resolves, so a cold load never hides launching from workspaces that have it.
 * The server-side guard on `launchAds`/`relaunchMetaAd` is what enforces the kill switch.
 */
export const useIsAdStudioLaunchEnabled = (): boolean => {
  const { disableAdStudioLaunch } = useFlags();
  const isAgentLaunchEnabled = useExternalResourceLaunchEnabled();

  return !disableAdStudioLaunch && !isAgentLaunchEnabled;
};
